import imagesLoaded from 'imagesloaded'
import Controller from './Controller'

/**
* Controller with imagesLoaded prototype
**/
class ControllerImgLoad extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.loadImagesStart();
  }
  /**
   * load images start
   */
  loadImagesStart() {
    this.imagesLoaded = false;
    this.viewCanStart = false;
    if (this.view) {
      const container = document.querySelector(this.getContainerSelector())
      container.classList.add("as-images-loading")
      this.view.loadImagesStart(container);
    }
    imagesLoaded(this.getContainerSelector(), $.proxy(this.loadImagesComplete, this));
  }
  /**
   * load images complete
   */
  loadImagesComplete(e) {
    this.imagesLoaded = true;
    if (this.view) {
      const container = document.querySelector(this.getContainerSelector())
      container.classList.remove("as-images-loading")
      this.view.loadImagesComplete(container);
    }
    if (this.viewCanStart) {
      super.onViewShow(e);
      super.onViewShown(e);
    }
  }
  /**
  * on view hide - animation out / hide start
  * request is loaded and fresh content is ready to init 
  * loaded content available <code>e.target.$freshContent</code>
  * @param {Event} e
  **/  
  onViewHide(e) {
    this.viewCanStart = false;
    super.onViewHide(e);
  }
  /**
  * on view show - animation in / show start
  * @param {Event} e
  **/
  onViewShow(e) { 
    this.viewCanStart = true;
    if (this.imagesLoaded) {
      super.onViewShow(e);
    }
  }
  /**
  * on view shown - animation in / show complete
  * @param {Event} e
  **/
  onViewShown(e) {
    if (this.imagesLoaded) {
      super.onViewShown(e);
    }
  }
}

export default ControllerImgLoad;